import React from 'react';
import { IconBase } from '../Base';
export const IconDrag = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("line", { x1: "4.75", y1: "6", x2: "11.25", y2: "6", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round" }),
        React.createElement("line", { x1: "4.75", y1: "10", x2: "11.25", y2: "10", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round" })));
};
//# sourceMappingURL=Drag.js.map